import { Colors, Lightning, Storage } from "@lightningjs/sdk";
import { SettingsItemText } from "../layout/SettingsItemText";
import QRCode from "qrcode";
import configs from "../../../../../lib/configs";
import theme from "../../../../../lib/theme";
import { STORAGE_KEYS } from "../../../../../lib/utils";
import { fetchAndCacheAppInfo, type AppInfo } from "../../../../../api/queries";

interface SettingsContactTemplateSpec extends Lightning.Component.TemplateSpec {
    Layout: typeof SettingsItemText;
}

class SettingsContactContent
    extends Lightning.Component<any>
    implements Lightning.Component.ImplementTemplateSpec<any>
{
    readonly QR = this.getByRef("QR")!;
    readonly Text = this.getByRef("Text")!;

    static override _template(): Lightning.Component.Template<any> {
        return {
            flex: { direction: "column", alignItems: "center", justifyContent: "center" },
            w: 540,
            QR: { w: 540, h: 540 },
            Text: {
                y: 24,
                width: 340,
                text: {
                    text: "",
                    textAlign: "center",
                    textWidth: 340,
                    textColor: Colors(theme.colors.text.secondary).get(),
                    fontSize: 28,
                    wrap: true,
                    wordWrapWidth: 800
                }
            }
        };
    }

    override _init() {
        void this._refresh();
    }

    override _active() {
        void this._refresh();
    }

    private async _refresh() {
        await this._render();
        const fresh = await fetchAndCacheAppInfo();
        if (fresh) await this._render();
    }

    private async _render() {
        const appInfo = Storage.get(STORAGE_KEYS.appInfo) as AppInfo | undefined;
        const cmsEmail = appInfo?.branding?.contactEmail ?? null;
        const email = cmsEmail || configs.settings.providerEmail || "";

        this.Text.patch({ text: { text: email } });

        if (!email) return;
        try {
            this.QR.patch({
                src: await QRCode.toDataURL(email, {
                    errorCorrectionLevel: "H",
                    type: "image/jpeg"
                })
            });
        } catch (err) {
            console.warn("Contact QR encode failed:", err);
        }
    }
}

export class SettingsContact
    extends Lightning.Component<SettingsContactTemplateSpec>
    implements Lightning.Component.ImplementTemplateSpec<SettingsContactTemplateSpec>
{
    readonly SettingsItem = this.getByRef("Layout")!;

    static override _template(): Lightning.Component.Template<SettingsContactTemplateSpec> {
        return {
            Layout: {
                type: SettingsItemText,
                content: SettingsContactContent,
                title: "about.contact"
            }
        };
    }

    override _getFocused() {
        return this.SettingsItem;
    }

    override _handleEnter() {
        // Router.focusWidget("Terms");
    }

    _handleClick() {
        this._handleEnter();
    }

    _handleHover() {
        this.fireAncestors("$listItemHover", this);
    }
}
